import React, { useState } from "react";
import { Modal, ModalBody } from "reactstrap";

const VerImg = (props) => {
  const { open, setOpen, card } = props;
  const [imgSize, setImgSize] = useState({ width: 0, height: 0 });

  const onImgLoad = ({ target: img }) => {
    setImgSize({ width: img.naturalWidth, height: img.naturalHeight });
  };

  const getImgStyle = () => {
    const maxHeight = window.innerHeight;
    const maxWidth = window.innerWidth;
    const heightRatio = maxHeight / imgSize.height;
    const widthRatio = maxWidth / imgSize.width;
    const ratio = Math.min(heightRatio, widthRatio, 1); 

    return {
      width: `${imgSize.width * ratio}px`,
      height: `${imgSize.height * ratio}px`,
      maxWidth: "100%",
      maxHeight: "100%",
      objectFit: "contain",
      pointerEvents: "none",
      zIndex: 20000,
    };
  };


  return (
    <Modal
      isOpen={open}
      toggle={() => setOpen(!open)}
      className="modal-dialog-centered ver-img"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100vw",
        height: "100vh",
        maxWidth: "100%",
        margin: 0,
        padding: 0,
      }}
      backdrop={true}
    >
      <ModalBody
        onClick={() => {
           setOpen(!open);
        }}
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 0,
          position: "relative",
          background: "transparent",
        }}
      >
        {/* {isMobile && (
          <button
            onClick={() => setOpen(false)}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              border: "none",
              background: "#000",
              color: "#fff",
              fontSize: "20px",
              padding: "0px 8px",
              borderRadius: "50%",
              cursor: "pointer",
              boxShadow: "0 2px 5px rgba(0,0,0,0.5)",
              zIndex: 1050,
            }}
          >
            &times;
          </button>
        )} */}
        <img
          onLoad={onImgLoad}
          style={getImgStyle()}
          alt={card?.abaTitulo ? card.abaTitulo : ""}
          src={card?.url + process.env.REACT_APP_TOKEN_BLOB}
        />
      </ModalBody>
    </Modal>
  );
};
export default VerImg;
